import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { alignItems, display, position, space } from 'styled-system';

import { transitionProperty } from '../../theme/system-utilities';
import { Button } from './index';

const UnstyledMovableButton = styled(Button)<any>`
  ${display};
  ${space};
  ${position};
  ${alignItems};
  ${transitionProperty};

  ${({ hidden, hideToLeft, hideToRight }) =>
    hidden
      ? css`
          opacity: 0;
          pointer-events: none;
          ${hideToLeft &&
          css`
            left: ${hideToLeft};
          `}
          ${hideToRight &&
          css`
            right: ${hideToRight};
          `}
        `
      : css`
          opacity: 1;
          left: 0;
          right: 0;
          pointer-events: initial;
        `}
`;

const MovableButton = (props: ComponentProps<typeof UnstyledMovableButton>) => (
  <UnstyledMovableButton
    display="flex"
    alignItems="center"
    position="relative"
    kind="bare"
    {...props}
  />
);

export default MovableButton;
